var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border-top":"1px solid","margin-left":"13px","margin-right":"13px","padding-top":"20px"}},[_c('h3',[_vm._v("Diagnose: "),_c('b',[_vm._v(_vm._s(_vm.bestaetigteDiagnose))])]),(_vm.patientIsWoman)?_c('h4',[_vm._v("Schwanger: "),_c('b',[_vm._v(_vm._s(_vm.patientIsPregnant))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }